module.exports = __webpack_public_path__ + "../resources/img/ic_re_rain_solid.66ef2e8e.svg";